(function () {
  var labels = {
    addToCart: 'Add to Bag',
    soldOut: 'Sold Out',
    adding: 'Adding…',
    added: 'Added to Bag'
  };

  var desktopMq = window.matchMedia('(min-width: 901px)');

  function alignLeadShot(section) {
    if (!section) return;
    var title = section.querySelector('.alleras-lookbook__title');
    var tile2 = section.querySelector('.alleras-lookbook__grid > .alleras-lookbook__tile:nth-child(2)');
    if (!title || !tile2) return;

    if (!desktopMq.matches) {
      tile2.style.marginTop = '';
      return;
    }

    tile2.style.marginTop = '0px';
    var offset = title.getBoundingClientRect().top - tile2.getBoundingClientRect().top;
    tile2.style.marginTop = offset + 'px';
  }

  function alignAllLeadShots() {
    document.querySelectorAll('.alleras-lookbook--collection').forEach(alignLeadShot);
  }

  function watchLeadShotImages(section) {
    if (!section) return;
    section.querySelectorAll('.alleras-lookbook__media img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        alignLeadShot(section);
      }, { once: true });
    });
  }

  /**
   * iOS Safari often ignores the HTML autoplay attribute; muted + playsInline + play() is required.
   * Do not re-play on pause — lightbox sync pauses inactive frames on purpose.
   */
  function wireMutedAutoplay(video) {
    if (!(video instanceof HTMLVideoElement) || video.dataset.autoplayWired === 'true') return;
    if (!video.autoplay && !video.hasAttribute('autoplay')) return;

    video.dataset.autoplayWired = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.controls = false;

    var ensurePlaying = function () {
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    };

    ensurePlaying();
    video.addEventListener('loadeddata', ensurePlaying);
    video.addEventListener('canplay', ensurePlaying);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ensurePlaying();
    });
  }

  function wireSectionAutoplay(section) {
    if (!section) return;
    section.querySelectorAll('video[autoplay]').forEach(wireMutedAutoplay);
  }

  function initSection(section) {
    if (!section || section.dataset.allerasLookbookInit) return;
    section.dataset.allerasLookbookInit = 'true';

    alignLeadShot(section);
    watchLeadShotImages(section);
    wireSectionAutoplay(section);

    var sectionId = section.getAttribute('data-alleras-lookbook-section');
    var lightbox = document.getElementById('alleras-lookbook-lightbox-' + sectionId);
    if (!lightbox) return;

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var shots = Array.prototype.slice.call(section.querySelectorAll('[data-alleras-lookbook-shot]'));
    if (!shots.length) return;

    function getShotOrderIndex(shot) {
      var order = parseInt(shot.getAttribute('data-shot-index'), 10);
      return isNaN(order) ? 0 : order;
    }

    shots.sort(function (a, b) {
      return getShotOrderIndex(a) - getShotOrderIndex(b);
    });

    var mediaEl = lightbox.querySelector('[data-alleras-lookbook-media]');
    var shopEl = lightbox.querySelector('[data-alleras-lookbook-shop]');
    var panelFrame = lightbox.querySelector('[data-alleras-lookbook-panel-frame]');
    var currentIndex = 0;
    var mediaIndex = 0;
    var previousFocus = null;

    function panelTemplate(shot) {
      var template = shot.querySelector('template');
      return template ? template.content.firstElementChild : null;
    }

    var SWIPE_THRESHOLD = 40;
    var DRAG_THRESHOLD = 10;
    var WHEEL_SETTLE_MS = 180;
    var WHEEL_REF_WIDTH = 360;

    var frames = [];
    var frameIndex = 0;
    var trackEl = null;
    var viewportEl = null;
    var scrubGesture = null;
    var wheelState = { active: false, baseIndex: 0, delta: 0, timer: null, totalPx: 0 };

    function normaliseWheelDelta(event, width) {
      var delta = event.deltaX;
      if (!delta) return 0;
      if (event.deltaMode === 1) delta *= 16;
      else if (event.deltaMode === 2) delta *= width;
      return delta;
    }

    function getTrackWidth() {
      return (viewportEl && viewportEl.clientWidth) || (mediaEl && mediaEl.clientWidth) || 1;
    }

    function syncFrameSizes() {
      if (!viewportEl || !frames.length) return;
      var width = getTrackWidth();
      frames.forEach(function (frame) {
        if (!frame.el) return;
        frame.el.style.flex = '0 0 ' + width + 'px';
        frame.el.style.width = width + 'px';
        frame.el.style.minWidth = width + 'px';
        frame.el.style.maxWidth = width + 'px';
      });
    }

    function setTrackOffset(px, animate) {
      if (!trackEl) return;
      trackEl.classList.toggle('is-scrubbing', !animate);
      trackEl.style.transition = animate ? '' : 'none';
      trackEl.style.transform = 'translate3d(' + -px + 'px, 0, 0)';
    }

    function setTrackIndex(index, animate) {
      frameIndex = Math.max(0, Math.min(Math.max(0, frames.length - 1), index));
      syncFrameSizes();
      setTrackOffset(frameIndex * getTrackWidth(), animate);
      syncShopForFrame(frameIndex);
      syncFrameVideos(frameIndex);
    }

    function syncFrameVideos(activeIndex) {
      frames.forEach(function (frame, i) {
        if (!frame.el) return;
        frame.el.querySelectorAll('video').forEach(function (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          if (i === activeIndex) {
            if (typeof video.play === 'function') {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            }
          } else if (typeof video.pause === 'function') {
            video.pause();
            try {
              video.currentTime = 0;
            } catch (err) {}
          }
        });
      });
    }

    function syncShopForFrame(index) {
      if (!shopEl || !frames.length) return;
      var frame = frames[Math.max(0, Math.min(frames.length - 1, index))];
      if (!frame) return;

      currentIndex = frame.shotIndex;
      mediaIndex = frame.mediaIndex;

      var panel = panelTemplate(shots[frame.shotIndex]);
      var shopSource = panel ? panel.querySelector('[data-alleras-lookbook-panel-shop]') : null;

      shopEl.innerHTML = '';
      if (shopSource) shopEl.appendChild(shopSource.cloneNode(true));

      if (panelFrame) {
        panelFrame.classList.toggle('alleras-lookbook-lightbox__panel--no-shop', !shopSource);
      }
    }

    function eageriseMedia(root) {
      if (!root) return;
      root.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        img.decoding = 'async';
        img.setAttribute('fetchpriority', 'high');
        img.removeAttribute('hidden');
      });
    }

    function buildFrames() {
      frames = [];
      shots.forEach(function (shot, shotIndex) {
        var panel = panelTemplate(shot);
        if (!panel) return;

        var mediaSource = panel.querySelector('[data-alleras-lookbook-panel-media]');
        if (!mediaSource) return;

        var slides = Array.prototype.slice.call(
          mediaSource.querySelectorAll('[data-alleras-lookbook-media-slide]')
        );

        if (!slides.length) {
          frames.push({
            shotIndex: shotIndex,
            mediaIndex: 0,
            html: mediaSource.innerHTML
          });
          return;
        }

        slides.forEach(function (slide, mediaIndex) {
          frames.push({
            shotIndex: shotIndex,
            mediaIndex: mediaIndex,
            html: slide.innerHTML
          });
        });
      });
    }

    function ensureTrack() {
      if (!mediaEl) return;
      if (viewportEl && trackEl && frames.length && mediaEl.contains(viewportEl)) return;

      viewportEl = null;
      trackEl = null;
      buildFrames();
      mediaEl.innerHTML = '';

      viewportEl = document.createElement('div');
      viewportEl.className = 'alleras-lookbook-lightbox__viewport';
      viewportEl.setAttribute('data-alleras-lookbook-viewport', '');

      trackEl = document.createElement('div');
      trackEl.className = 'alleras-lookbook-lightbox__track';
      trackEl.setAttribute('data-alleras-lookbook-track', '');

      frames.forEach(function (frame, i) {
        var cell = document.createElement('div');
        cell.className = 'alleras-lookbook-lightbox__frame';
        cell.setAttribute('data-alleras-lookbook-frame', '');
        cell.setAttribute('data-shot-index', String(frame.shotIndex));
        cell.setAttribute('data-media-index', String(frame.mediaIndex));
        cell.innerHTML = frame.html;
        eageriseMedia(cell);
        frame.el = cell;
        trackEl.appendChild(cell);
      });

      viewportEl.appendChild(trackEl);
      mediaEl.appendChild(viewportEl);
      syncFrameSizes();
    }

    function findFrameIndex(shotIndex, mediaStart) {
      var matches = [];
      frames.forEach(function (frame, i) {
        if (frame.shotIndex === shotIndex) matches.push(i);
      });
      if (!matches.length) return 0;
      if (mediaStart === 'last') return matches[matches.length - 1];
      if (typeof mediaStart === 'number') {
        return matches[Math.max(0, Math.min(matches.length - 1, mediaStart))];
      }
      return matches[0];
    }

    function showShot(index, mediaStart) {
      if (!shots.length || !mediaEl || !shopEl) return;

      ensureTrack();
      currentIndex = (index + shots.length) % shots.length;
      var nextFrame = findFrameIndex(currentIndex, mediaStart);
      setTrackIndex(nextFrame, false);
      releaseNavLock();
    }

    function step(delta) {
      if (!frames.length) {
        releaseNavLock();
        return;
      }

      var next = frameIndex + delta;
      if (next < 0 || next >= frames.length) {
        // Soft wrap for keyboard / discrete nav.
        if (frames.length > 1) {
          next = (next + frames.length) % frames.length;
          setTrackIndex(next, false);
        }
        releaseNavLock();
        return;
      }

      setTrackIndex(next, true);
      releaseNavLock();
    }

    var navLock = false;
    var navLockTimer = null;

    function releaseNavLock() {
      navLock = false;
      if (navLockTimer) {
        window.clearTimeout(navLockTimer);
        navLockTimer = null;
      }
    }

    function navigate(delta) {
      if (!delta || navLock || lightbox.hidden) return;
      navLock = true;
      if (navLockTimer) window.clearTimeout(navLockTimer);
      step(delta);
      navLockTimer = window.setTimeout(releaseNavLock, 500);
    }

    function settleWheel() {
      wheelState.active = false;
      wheelState.timer = null;
      var width = getTrackWidth();
      var maxIndex = Math.max(0, frames.length - 1);
      var targetIndex = Math.round(wheelState.totalPx / width);
      targetIndex = Math.max(0, Math.min(maxIndex, targetIndex));
      setTrackIndex(targetIndex, true);
      wheelState.delta = 0;
      wheelState.totalPx = targetIndex * width;
    }

    function onTrackWheel(event) {
      if (lightbox.hidden || scrubGesture) return;
      if (Math.abs(event.deltaY) > Math.abs(event.deltaX) * 1.25) return;
      if (frames.length < 2) return;

      var width = getTrackWidth();
      var delta = normaliseWheelDelta(event, width);
      if (!delta) return;

      delta *= Math.max(1, width / WHEEL_REF_WIDTH);
      var maxIndex = frames.length - 1;

      if (!wheelState.active) {
        wheelState.active = true;
        wheelState.baseIndex = frameIndex;
        wheelState.delta = 0;
        wheelState.totalPx = frameIndex * width;
      }

      event.preventDefault();
      wheelState.delta += delta;
      wheelState.totalPx = wheelState.baseIndex * width + wheelState.delta;
      wheelState.totalPx = Math.max(0, Math.min(maxIndex * width, wheelState.totalPx));
      wheelState.delta = wheelState.totalPx - wheelState.baseIndex * width;
      setTrackOffset(wheelState.totalPx, false);

      if (wheelState.timer) window.clearTimeout(wheelState.timer);
      wheelState.timer = window.setTimeout(settleWheel, WHEEL_SETTLE_MS);
    }

    function cleanupScrubGesture() {
      document.removeEventListener('pointermove', onScrubMove);
      document.removeEventListener('pointerup', onScrubEnd);
      document.removeEventListener('pointercancel', onScrubEnd);
      if (viewportEl) viewportEl.classList.remove('is-dragging');
      if (trackEl) trackEl.classList.remove('is-scrubbing');
      scrubGesture = null;
    }

    function onScrubMove(event) {
      if (!scrubGesture || event.pointerId !== scrubGesture.pointerId) return;

      var dx = event.clientX - scrubGesture.startX;
      var dy = event.clientY - scrubGesture.startY;

      if (!scrubGesture.moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          cleanupScrubGesture();
          return;
        }
        scrubGesture.moved = true;
        if (viewportEl) viewportEl.classList.add('is-dragging');
        if (trackEl) trackEl.classList.add('is-scrubbing');
      }

      var width = getTrackWidth();
      var maxPx = Math.max(0, frames.length - 1) * width;
      var nextPx = Math.max(0, Math.min(maxPx, scrubGesture.startPx - dx));
      setTrackOffset(nextPx, false);
      scrubGesture.currentPx = nextPx;
    }

    function onScrubEnd(event) {
      if (!scrubGesture || event.pointerId !== scrubGesture.pointerId) return;

      var width = getTrackWidth();
      var currentPx = scrubGesture.currentPx;
      var startIndex = scrubGesture.startIndex;
      var moved = scrubGesture.moved;
      cleanupScrubGesture();

      if (!moved) {
        setTrackIndex(frameIndex, true);
        return;
      }

      var targetIndex = Math.round(currentPx / width);
      targetIndex = Math.max(0, Math.min(frames.length - 1, targetIndex));

      // If rounding stayed put but drag passed threshold, commit one step.
      if (targetIndex === startIndex) {
        var drag = currentPx - startIndex * width;
        if (Math.abs(drag) >= SWIPE_THRESHOLD) {
          targetIndex = startIndex + (drag > 0 ? 1 : -1);
          targetIndex = Math.max(0, Math.min(frames.length - 1, targetIndex));
        }
      }

      setTrackIndex(targetIndex, true);
    }

    function bindLightboxSwipe() {
      var visual = lightbox.querySelector('[data-alleras-lookbook-visual]');
      if (!visual || visual.dataset.allerasLookbookSwipeInit === 'true') return;
      visual.dataset.allerasLookbookSwipeInit = 'true';

      visual.addEventListener('pointerdown', function (event) {
        if (lightbox.hidden || frames.length < 2) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('button, input, label, select, a')) return;

        ensureTrack();
        cleanupScrubGesture();
        if (wheelState.timer) window.clearTimeout(wheelState.timer);
        wheelState.active = false;

        var width = getTrackWidth();
        scrubGesture = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startPx: frameIndex * width,
          startIndex: frameIndex,
          currentPx: frameIndex * width,
          moved: false
        };

        if (typeof visual.setPointerCapture === 'function') {
          try {
            visual.setPointerCapture(event.pointerId);
          } catch (err) {}
        }

        document.addEventListener('pointermove', onScrubMove);
        document.addEventListener('pointerup', onScrubEnd);
        document.addEventListener('pointercancel', onScrubEnd);
      });

      visual.addEventListener('wheel', onTrackWheel, { passive: false });
    }

    function onLightboxKeydown(event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        navigate(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(1);
      }
    }

    function openLightbox(index) {
      previousFocus = document.activeElement;
      bindLightboxSwipe();
      showShot(index, 0);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('alleras-lookbook-lightbox-open');

      var dialog = lightbox.querySelector('[data-alleras-lookbook-dialog]');
      if (dialog) dialog.scrollTop = 0;

      // Remeasure after paint so frame widths match the clipped viewport.
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          setTrackIndex(frameIndex, false);
        });
      }

      var closeBtn = lightbox.querySelector('.alleras-lookbook-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('alleras-lookbook-lightbox-open');
      if (mediaEl) mediaEl.innerHTML = '';
      if (shopEl) shopEl.innerHTML = '';
      viewportEl = null;
      trackEl = null;
      frames = [];
      frameIndex = 0;
      mediaIndex = 0;
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      previousFocus = null;
    }

    function onOpenClick(event) {
      var button = event.target.closest('[data-alleras-lookbook-open]');
      if (!button || button.disabled) return;

      var shot = button.closest('[data-alleras-lookbook-shot]');
      if (!shot || !section.contains(shot)) return;

      event.preventDefault();
      var index = shots.indexOf(shot);
      if (index < 0) return;
      openLightbox(index);
    }

    function onCloseClick(event) {
      if (event.target.closest('[data-alleras-lookbook-close]')) {
        event.preventDefault();
        closeLightbox();
      }
    }

    lightbox.querySelectorAll('[data-alleras-lookbook-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', onCloseClick);
    });

    function onSubmit(event) {
      var form = event.target.closest('[data-alleras-lookbook-atc-form]');
      if (!form || !lightbox.contains(form)) return;

      event.preventDefault();

      var submitBtn = form.querySelector('[data-alleras-lookbook-atc-submit]');
      var select = form.querySelector('[data-alleras-lookbook-atc-select]');
      var hiddenId = form.querySelector('input[name="id"][type="hidden"]');
      var variantId = select ? select.value : hiddenId ? hiddenId.value : '';

      if (!variantId) {
        if (select) select.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = labels.adding;
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (window.allerasWishlist) window.allerasWishlist.applyCart(cart);
          if (submitBtn) {
            submitBtn.textContent = labels.added;
            window.setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = labels.addToCart;
            }, 1400);
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = labels.addToCart;
          }
        });
    }

    bindLightboxSwipe();

    window.addEventListener('resize', function () {
      if (lightbox.hidden || !frames.length) return;
      setTrackIndex(frameIndex, false);
    });

    section.addEventListener('click', onOpenClick);
    document.addEventListener('keydown', onLightboxKeydown);
    lightbox.addEventListener('submit', onSubmit);
  }

  function init() {
    document.querySelectorAll('[data-alleras-lookbook-section]').forEach(initSection);
    alignAllLeadShots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', alignAllLeadShots);
  window.addEventListener('resize', alignAllLeadShots);
  if (desktopMq.addEventListener) {
    desktopMq.addEventListener('change', alignAllLeadShots);
  } else if (desktopMq.addListener) {
    desktopMq.addListener(alignAllLeadShots);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-alleras-lookbook-section]') || event.target;
    if (section && section.matches('[data-alleras-lookbook-section]')) {
      delete section.dataset.allerasLookbookInit;
      initSection(section);
    }
    alignAllLeadShots();
  });
})();
